import useAuthToken from 'auth/useAuthToken';
import siconfiPages from 'config/siconfi.config';
import { intersection, isArray } from 'lodash';
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import AuthService from 'services/AuthService';
import { features } from 'config/features.config';
import CircularProgress from '@mui/material/CircularProgress';
import useSessionWarningToast from 'auth/useSessionWarningToast';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function useUrlPublica() {
  const location = useLocation();

  return features.filter(
    feature => (feature.route.url === location.pathname.split("/")[1]) && feature.public === true
  ).length > 0;
}

export function useFeature() {
  const location = useLocation();
  // console.log('location.pathname ' + location.pathname);
  // console.log('location.pathname.split("/")[1] ' + location.pathname.split("/")[1]);
  const path = location.pathname.split("/")[1] ? location.pathname.split("/")[1] : '/';
  // console.log('path ' + path);

  return features.filter(
    feature => (feature.route.url === path)
  )[0];
}

function AuthProvider({children}) {
  const navigate = useNavigate();
  const isUrlPublica = useUrlPublica();
  const feature = useFeature();

  const { getCredentials, removeAuth, sessionWarning, sessionExpiresAt } = useAuthToken();
  const credentials = getCredentials();

  const [isProcessingReverseSignOn, setIsProcessingReverseSignOn] = useState(false);
  const isAuthenticated = credentials && credentials.cpf != null;

  useSessionWarningToast(sessionWarning, isAuthenticated, sessionExpiresAt);

  const loginPublico = async () => {
    try {
        await AuthService.getAll();
    } catch(error) {
      console.warn('Erro no login', error);
    } 
  }

  useEffect(() => {
    if (isProcessingReverseSignOn) {
      return;
    } else if (!isAuthenticated) {
      if (feature?.id === 'HOME') {
        navigate('/consultas-publicas', { replace: true })
      } else {
        if (isUrlPublica) {
          loginPublico();
        } else {
          navigate('/Negado', { replace: true })
        }
      }
    }
  }, [JSON.stringify(credentials), isUrlPublica, isAuthenticated, navigate, feature, isProcessingReverseSignOn]);

  const contextValue = useMemo(() => {
    const siglas = (credentials?.siglas?.split?.(',') ?? []);  //.filter(s => !s.includes('ALT')) ; // retirar

    const isAuthorized = (requires) => {

      const requirements = (
        isArray(requires)
        ? requires
        : requires == null
          ? []
          : [requires]
      );

      return (
        credentials?.acessoTotal ||
        !requirements?.length || 
        !!intersection(siglas, requirements)?.length
      );
    }

    const reverseSignOn = async ({redirectToListarPerfil, redirectToSelecionarVinculo, redirectToMinhaConta} = {}) => {
      setIsProcessingReverseSignOn(true);
      const response = await AuthService.getReverseSignOnToken();
      const auth = response?.data?.reverseSignOnToken;
      
      let redirectTo = "";
      if (!!redirectToListarPerfil) {
        redirectTo = "&redirectTo=listar_perfil";
      } else if (!!redirectToSelecionarVinculo) {
        redirectTo = "&redirectTo=selecionar_vinculo";
      } else if (!!redirectToMinhaConta) {
        redirectTo = "&redirectTo=minha_conta";
      }

      const remoteAppUrl = `${siconfiPages.LOGIN_INTEGRACAO}?Authorization=${auth}${redirectTo}&modulo=3`;
      window.location.replace(remoteAppUrl);
      removeAuth();
    };

    const remoteLogout = () => {
      // window.location.replace(siconfiPages.LOGOUT);
      navigate('/Negado', { replace: true })
      removeAuth();
    }
    
    return {
      credentials,
      removeAuth,
      reverseSignOn,
      remoteLogout,
      siglas,
      isAuthenticated,
      isAuthorized,
      isProcessingReverseSignOn,
    }
  }, [JSON.stringify(credentials)]);

  return(
    <AuthContext.Provider value={contextValue}>
      {/* {isProcessingReverseSignOn ? <CircularProgress color="inherit" size={20} /> : ""} */}
      {isProcessingReverseSignOn ? 
        <div className="loading-spinner__spinner">     
          <svg width="100%" height="100%" 
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" 
            preserveAspectRatio="xMidYMid">
          
            <circle className="loading-spinner__outer-circle" cx="50" cy="50" fill="none" strokeLinecap="round" r="40" 
            strokeWidth="10" stroke="#ffffff" strokeDasharray="62.83185307179586 62.83185307179586" >        
            </circle>

            <circle className="loading-spinner__inner-circle" cx="50" cy="50" 
              fill="none" strokeLinecap="round" r="29" 
              strokeWidth="10" stroke="rgba(100%,100%,100%,0.516)" 
              strokeDasharray="45.553093477052 45.553093477052" 
              strokeDashoffset="45.553093477052">
            </circle>
          </svg>    
        </div>
      : ""}
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
